import React, { useCallback } from 'react';
import SwaggerUI from 'swagger-ui-react';
import { getLanguageHeaders } from 'cityads-v3/utils/apiUtils';
import { LanguageCode } from 'cityads-v3/types/auth';
import config from 'cityads-v3/config';

import classes from './Swagger.scss';

type SwaggerWrapperProps = {
  language: LanguageCode
}

export default function SwaggerWrapper({
  language
}: SwaggerWrapperProps) {

  const currentHost = window
    ? `${window.location.protocol}//${window.location.hostname}`
    : ''

  const requestInterceptor = useCallback((req) => {
    if (!req.loadSpec) {
      return req;
    }

    return {
      ...req,
      headers: {
        ...req ? req.headers : null,
        ...getLanguageHeaders(language),
      },
    };
  }, [language])

  const url = config.SWAGGER_URL.replace(/{LANGUAGE}/g, language)

  return (
    <div className={classes.swaggerWrapper}>
      {
        window ?
          (
            <SwaggerUI
              url={url}
              requestInterceptor={requestInterceptor}
              oauth2RedirectUrl={`${currentHost}/static/auth/oauth2-redirect.html`}
            />
          ) :
          null
      }
    </div>
  )
}
